import { createContext } from 'react';
import { observer } from 'mobx-react-lite';
import { FeatureStore } from 'core/stores/feature.store';

export const FeatureContext = createContext(new FeatureStore());

export const FeatureContextProvider = observer<any>(({ children, featureStore }: { children: any, featureStore: FeatureStore }) => (
  <FeatureContext.Provider value={featureStore}>{children}</FeatureContext.Provider>
));